exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customTableWithClr {\n  border-collapse: separate;\n  border-spacing: 0 5px;\n  width: 100%; }\n  .customTableWithClr th:first-child {\n    width: 40px; }\n  .customTableWithClr th:last-child {\n    width: 100px; }\n  .customTableWithClr th,\n  .customTableWithClr td {\n    padding: 8px; }\n  .customTableWithClr_tr {\n    background-color: #eeeeee; }\n  .customTableWithClr_txt_alignLeft {\n    text-align: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/customTableWithColors/CustomTableWithColors.style.scss
// module id = 1643
// module chunks = 0